<template lang="html" src="./ReportManager.html">

</template>

<script>
import { downloadReport } from '@/services/reports'
import { getVehicles } from '@/services/vehicle'
import { format } from 'date-fns'

export default {
  name: 'ReportingManager',

  data () {
    return {
      vehicles: [],
      passengerModel: {
        from_date: null,
        to_date: null,
        report_type: null,
        vehicle_id: null,
        route_id: null
      }
    }
  },

  mounted () {
    this.onLoadVehicles()
  },

  methods: {
    handleGenerateReport () {
      let queryParams = ''
      const m = this.passengerModel
      const updateDateAtr = (k, v) => {
        if (k.includes('date')) {
          return `${k}=${format(new Date(v), 'YYYY-MM-DD')}`
        }
        return `${k}=${v}`
      }
      Object.keys(m).forEach(k => {
        // only create queryParams for key with value
        if (m[k]) { queryParams = `${queryParams}${updateDateAtr(k, m[k])}&` }
      })

      downloadReport(queryParams)
    },

    onLoadVehicles () {
      getVehicles()
        .then(res => {
          this.vehicles = res.data
        })
        .catch(() => {
          this.$message.error('Error fetching vehicles from the server')
        })
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/reporting/ReportManager.vue